export default __webpack_public_path__ + "static/media/logo-01.d5da23cb.svg";